module.exports = __webpack_public_path__ + "img/fickett-&-crockett.1cf62c38.png";